import React from 'react';
import LoginCard from '../../components/Login/LoginCard.jsx';
import LoginTemplate from '../../components/Login/LoginTemplate.jsx';

export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.logoOptions = {
            default: {
                smallAtHeight: 840,
                hideAtHeight: 720,
                hideAtWidth: 380,
                contentHeight: "451px",
                largeScale: 1.3
            }
        };
    }

    render() {
        return (
            <LoginTemplate logoOptions={this.logoOptions} cardView={<LoginCard/>}/>
        );
    }
};



// WEBPACK FOOTER //
// app/views/Login/Login.jsx